import styled from "styled-components";

export const WorkPageBtns = styled.div`
  grid-area: btns;
`;
